import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4199fee1")

_pushScopeId("data-v-4199fee1")
const _hoisted_1 = {
  ref: "root",
  class: "Accordion"
}
const _hoisted_2 = { class: "Accordion__section-title" }
const _hoisted_3 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      ref: "inner",
      class: "Accordion__inner",
      onScroll: _cache[1] || (_cache[1] = (...args) => (_ctx.onScroll(...args)))
    }, [
      _createVNode("div", {
        class: "Accordion__fixed-title",
        style: _ctx.fixedTitleStyle
      }, _toDisplayString(_ctx.fixedTitle), 5),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (section, i) => {
        return (_openBlock(), _createBlock("div", {
          key: `section-${i}`,
          ref: _ctx.setSectionRefs,
          class: "Accordion__section",
          style: {
          zIndex: i,
        }
        }, [
          _createVNode("div", _hoisted_2, _toDisplayString(section.name), 1),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(section.items, (item, j) => {
            return (_openBlock(), _createBlock("div", {
              key: `section-${i}-${j}`,
              class: "Accordion__section-item-container",
              onClick: _withModifiers($event => (_ctx.$emit('item-click', { section, item })), ["stop"])
            }, [
              _renderSlot(_ctx.$slots, "default", {
                section: section,
                data: item
              }, () => [
                _createTextVNode(_toDisplayString(item), 1 /* TEXT */)
              ])
            ], 8, ["onClick"]))
          }), 128 /* KEYED_FRAGMENT */)),
          (section.id === 1 && _ctx.fixedTitle === '수리 부품 확인')
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "footer")
              ]))
            : _createCommentVNode("", true)
        ], 4))
      }), 128 /* KEYED_FRAGMENT */)),
      _renderSlot(_ctx.$slots, "footer")
    ], 544)
  ], 512))
})